import React from "react";
import { useDispatch, useSelector } from "react-redux";

import moment from "moment/moment";
import * as Yup from "yup";
import { commonStyle } from "../../commonStyle";
import flexStyles from "../../style/flex";
import textStyle from "../../style/typography";
import useValidator from "../../utils/useValidator";

import { Box, CircularProgress, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

import DateFilter from "../../Components/DateFilter";
import PrimaryButton from "../../Components/UI/Buttons/PrimaryButton";
import { StyledCard } from "../../Components/UI/Card";
import CardHeader from "../../Components/UI/CardHeader";
import ListingLayout from "../../Components/UI/ListingLayout";
import { exportReviews } from "../../Stores/SlickCareProfiles/actions";

const ReviewExport = () => {
  const dispatch = useDispatch();
  const commonClasses = commonStyle();
  const flexClasses = flexStyles();
  const textClasses = textStyle();

  const { activeLocation, isExporting } = useSelector(
    (state) => state.SlickCareProfilesReducer
  );

  const onSuccess = () => {
    clearFormState();
  };

  function onSubmit() {
    let payload = { ...values, location_id: activeLocation?.id };
    delete payload.date_range;
    dispatch(
      exportReviews(
        {
          data: payload,
          type: payload?.file_type,
          title: activeLocation?.title ?? "",
        },
        onSuccess
      )
    );
  }

  const { errors, touched, values, handleSubmit, setValues, clearFormState } =
    useValidator({
      initialValues: {
        from_date: "",
        to_date: "",
        type: "",
        file_type: "",
        location_id: "",
      },
      onSubmit,
      validationSchema: Yup.object({
        type: Yup.string().required("Type is Required!"),
        file_type: Yup.string().required("File type is Required!"),
        from_date: Yup.string().required("Date range is Required!"),
      }),
    });

  return (
    <ListingLayout
      title="Export"
      item="REVIEWS"
      hideAdd={true}
      hasFilter={false}
      showLocationToggle={true}
    >
      <StyledCard>
        <CardHeader
          title="Export Review"
          subtitle="Export reviews based on your preference"
        />
        <form onSubmit={handleSubmit}>
          {isExporting ? (
            <div className={commonClasses.loaderWrap}>
              <CircularProgress size="40px" />
            </div>
          ) : (
            <Box className={flexClasses.flexContainer}>
              <Box className={flexClasses.itemSMD}>
                <label className={textClasses.lable}>Date Range</label>
                <DateFilter
                  variant="outlined"
                  inputVariant="outlined"
                  id="filter-data-by-date"
                  value={values.date_range ?? ""}
                  onChange={(dateRange) => {
                    if (dateRange) {
                      setValues({
                        ...values,
                        from_date: moment(dateRange[0]).format("YYYY-MM-DD"),
                        to_date: moment(dateRange[1]).format("YYYY-MM-DD"),
                        date_range: dateRange,
                      });
                    }
                  }}
                />
                {touched.from_date && errors.from_date && (
                  <p className={commonClasses.errorText}>{errors?.from_date}</p>
                )}
              </Box>
              <Box className={flexClasses.itemSMD}>
                <label className={textClasses.lable}>Review Type</label>
                <Autocomplete
                  id="type-input"
                  options={["Published", "Not Published", "Both"]}
                  getOptionLabel={(option) => option ?? ""}
                  value={values.type ?? ""}
                  onChange={(event, newValue) => {
                    setValues({ ...values, type: newValue });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      placeholder={`Select Review Type`}
                      helperText={touched.type && errors.type}
                      error={!!(touched.type && errors.type)}
                    />
                  )}
                />
              </Box>
              <Box className={flexClasses.itemSMD}>
                <label className={textClasses.lable}>Type</label>
                <Autocomplete
                  id="type-input"
                  options={["PDF", "CSV"]}
                  getOptionLabel={(option) => option ?? ""}
                  value={values.file_type ?? ""}
                  onChange={(event, newValue) => {
                    setValues({ ...values, file_type: newValue });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      placeholder={`Select File Type`}
                      helperText={touched.file_type && errors.file_type}
                      error={!!(touched.file_type && errors.file_type)}
                    />
                  )}
                />
              </Box>
            </Box>
          )}
          <Box style={{ marginTop: 18 }}>
            <PrimaryButton
              hideIcon={true}
              type="submit"
              disabled={Object.keys(errors).length > 0 || isExporting}
              hasCustomLabel={true}
            >
              {isExporting ? `Exporting` : `Export`}
            </PrimaryButton>
          </Box>
        </form>
      </StyledCard>
    </ListingLayout>
  );
};

export default ReviewExport;
